<!-- Translated: yes -->
<template>
  <button v-ripple class="component" @click="toggleClick">
    <span class="icon"><icon v-show="getStatus" :name="icon" :scale="iconscale"></icon></span>
    <span class="inline-block" v-show="getStatus">{{ label }}</span>
    <span class="inline-block icon" v-show="!getStatus">{{ closeLabel }} <icon name="times-white" :scale="1"></icon></span>
  </button>
</template>

<script>
export default {
  props: {
    label: {},
    closeLabel: {},
    icon: {},
    status: {},
    // 'clicked',
    iconscale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    getStatus() {
      return !this.status;
    },
  },
  methods: {
    toggleClick() {
      this.getStatus = !this.getStatus;
      this.$emit('clicked', this.getStatus);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  button-reset()
  display: inline-block
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 0.5rem 1rem 0.3rem;
  line-height 21px
  font-weight bold
  font-size 11px
  cursor pointer
  transition-ease()
  &:hover
    border-color alpha(deep-blue, .5)
  &:focus
    outline 1px solid rgba(0, 85, 128, 0.1)
    border-color deep-blue
    // outline-shadow(deep-blue)

  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white
.icon
  position: relative;
  top: -1px
  svg
    vertical-align middle
</style>



// WEBPACK FOOTER //
// OutlineButton.vue?db6c95de